import { Modal as MuiModal } from '@mui/material';
import beforeAfterImg from '@client/images/previews/beforeafter.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import * as styles from './BeforeAfterPhotoModal.css';

type BeforeAfterPhotoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const BeforeAfterPhotoModal = ({
  isOpen,
  onClose,
}: BeforeAfterPhotoModalProps) => (
  <MuiModal open={isOpen} onClose={onClose}>
    <div className={styles.modal}>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close"
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
      <img src={beforeAfterImg} alt="" className={styles.image} />
      <div className={styles.content}>
        <h1 className={styles.title}>Before/After Image</h1>
        <p className={styles.description}>
          For best results, we recommend the following to create visually
          beautiful before/after photos:
        </p>
        <ul className={styles.bullets}>
          <li>Put 2 vertical photos side-by-side</li>
          <li>Avoid any dividing lines between the 2 photos</li>
          <li>Final image should be square</li>
          <li>
            See our{' '}
            <a
              href="https://www.canva.com/design/DAFvBafZGLE/Jzl_s8ChkDTnk1KecOK7xA/view?utm_content=DAFvBafZGLE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              Canva
            </a>{' '}
            template
          </li>
        </ul>
      </div>
    </div>
  </MuiModal>
);
